import {makeFn} from '@snek-at/functions'

export const fn = makeFn({
  url:
    'https://schettn-schett-net-ami-p4xp5ppr395v-3010.githubpreview.dev/graphql'
})
